import { RecalibrationEntry } from "./business_unit_model";

export const DepartmentStatus = {
  active: "Active",
  inactive: "Inactive",
} as const;
export type DepartmentStatus =
  (typeof DepartmentStatus)[keyof typeof DepartmentStatus];

export interface Department {
  id?: string;
  _id?: any;
  name: string;
  code: string;
  status?: DepartmentStatus;
  created_at?: Date;
  created_by?: string;
  created_by_name?: string;
  updated_at?: Date;
  updated_by?: string;
  updated_by_name?: string;
  deleted?: boolean;
  // --- Phase 4
  annual_estimate?: number;
  current_fy?: string;
  monthly_slices?: number[];
  recalibration_history?: RecalibrationEntry[];
  // --- Phase 7C
  recurrence_months?: number;
}

export const departmentDefaultValue: Department = {
  name: "",
  code: "",
  status: "Active",
};

export interface DepartmentFilterData {
  page: number;
  count: number;
  search?: string;
  status?: string;
  sort?: string;
  sort_order?: number;
}
